var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInconsistent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.354,
    height: 35.415,
    viewBox: "0 0 23.354 35.415",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1827",
    "data-name": "Group 1827",
    transform: "translate(0 0)",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1222",
    "data-name": "Path 1222",
    d: "M204.331,253.62H189.34a.692.692,0,0,0-.692.692v5.434h-2.477a.7.7,0,0,0-.693.68v5.52h-3.12a.693.693,0,0,0-.692.693v6.11a.7.7,0,0,0,.692.692l21.969.082h0a.688.688,0,0,0,.692-.692V254.316a.692.692,0,0,0-.688-.7ZM190.033,255h10.84v4.745h-10.84Zm-3.169,6.131h12.07v4.815h-12.07Zm9.8,10.953-13.614-.053v-4.685h13.614Zm6.974.028-5.589-.024v-4.742h1.564a.693.693,0,0,0,.693-.692v-5.524h1.246a.692.692,0,0,0,.692-.692V255h1.381Z",
    transform: "translate(-181.666 -238.108)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1223",
    "data-name": "Path 1223",
    d: "M306.86,45.82a.692.692,0,0,0-.656-.481h-4.721l-1.45-4.481h0a.692.692,0,0,0-1.316,0l-1.45,4.481h-4.721a.7.7,0,0,0-.66.481.689.689,0,0,0,.253.774l3.825,2.766L294.5,53.841h0a.693.693,0,0,0,.249.774.684.684,0,0,0,.815,0l3.817-2.782,3.813,2.782a.692.692,0,0,0,1.067-.774l-1.47-4.481,3.825-2.766h0a.689.689,0,0,0,.248-.774Zm-5.3,2.717a.689.689,0,0,0-.253.774l.957,2.929-2.485-1.817h0a.693.693,0,0,0-.815,0l-2.481,1.817.957-2.929h0a.689.689,0,0,0-.253-.774l-2.509-1.8h3.084a.693.693,0,0,0,.66-.481l.945-2.929.945,2.929h0a.684.684,0,0,0,.652.485h3.084Z",
    transform: "translate(-283.836 -40.381)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1224",
    "data-name": "Path 1224",
    d: "M238.711,141.5a.684.684,0,0,0-.917.334l-2.7,5.817a.688.688,0,0,0,.338.921.663.663,0,0,0,.289.065.692.692,0,0,0,.627-.407l2.7-5.821a.685.685,0,0,0-.338-.908Z",
    transform: "translate(-231.146 -134.087)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1225",
    "data-name": "Path 1225",
    d: "M284.3,165.01a.692.692,0,0,0-.912.354l-1.336,3.01a.7.7,0,0,0,.354.917.679.679,0,0,0,.281.057.692.692,0,0,0,.631-.407l1.332-3.014a.692.692,0,0,0-.35-.916Z",
    transform: "translate(-274.69 -155.889)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInconsistent);
export default __webpack_public_path__ + "static/media/Inconsistent.90e6ff6f2f9491fdccd1031a1eb04272.svg";
export { ForwardRef as ReactComponent };